





















import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import FlTruncatableSpan from '@/components/FlTruncatableSpan.vue';

@Component({
  components: {
    ValidationProvider,
    FlTruncatableSpan,
  },
})
export default class FlShow extends Vue {
  @Prop({ default: '' }) private value!: any;
  @Prop({
    default: function () {
      return {};
    },
  })
  private rules?: object;
  @Prop({ default: '' }) private label!: string;
  @Prop({ default: 'text-right' }) private labelClass!: string;
  @Prop({ default: '' }) private fieldClass!: string;
  @Prop({ default: false }) private openInputField!: boolean;
  @Prop({ default: '' }) private gridType!: string;
  @Prop({ default: () => [] }) private options!: object[];
  @Prop({ default: () => [] }) private errors?: string[];
  @Prop({ default: false }) private disabled?: string[];
  @Prop({ default: false }) private alert?: boolean;
  @Prop({ default: true }) private useI18n: boolean;
  @Emit('input')
  input(newValue: any) {
    return newValue;
  }
  get inputValue() {
    return this.value;
  }
  set inputValue(newValue: any) {
    const inputValue = !newValue ? null : newValue;
    this.input(inputValue);
  }
  get flErrors() {
    return (this.errors as any)[0];
  }
  get labelAddClass() {
    let setClass = this.labelClass;
    if (!this.label) {
      return setClass;
    }

    if (this.gridType == 'label-1') {
      setClass += ' col-span-1';
    } else if (this.gridType == 'label-6') {
      setClass += ' col-span-6';
    } else if (this.gridType == 'label-2') {
      setClass += ' col-span-2';
    } else {
      setClass += ' col-span-4';
    }
    return setClass;
  }
  get fieldAddClass() {
    let setClass = this.fieldClass;
    if (!this.label) {
      setClass += ' col-span-12';
      return setClass;
    }
    if (this.gridType == 'label-1') {
      setClass += ' col-span-11';
    } else if (this.gridType == 'label-6') {
      setClass += ' col-span-6';
    } else if (this.gridType == 'label-2') {
      setClass += ' col-span-10';
    } else {
      setClass += ' col-span-8';
    }
    return setClass;
  }
  get errorAddClass() {
    let setClass = '';
    if (!this.label) {
      setClass += 'col-start-1 col-span-12';
      return setClass;
    }
    if (this.gridType == 'label-1') {
      setClass += 'col-start-1 col-span-11';
    } else if (this.gridType == 'label-6') {
      setClass += 'col-start-7 col-span-6';
    } else if (this.gridType == 'label-2') {
      setClass += 'col-start-3 col-span-10';
    } else {
      setClass += 'col-start-5 col-span-8';
    }
    return setClass;
  }
  get displayValue() {
    if (this.options.length == 0) {
      return this.value;
    }

    const labelName: any = this.options.filter((item: any) => item.value == this.value);
    if (labelName.length == 0) {
      return this.value;
    }
    if (this.useI18n) {
      return this.$t(labelName[0].text);
    } else {
      return labelName[0].text;
    }
  }
}
